/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form/immutable';
import QueuesForm from './layout';
import { formValidation } from './validation';

import {
  currentTenantSlas,
  getMatchmaker2Enabled,
  getQueuesFormInitialValues,
  getQueuesPageDependentEntities,
  getSelectedQueueVersionsNames,
  getSelectedVersionQuerylevelCount,
  isAllQueuesFormDependenciesFetched,
} from '../../../redux/modules/entities/queues/selectors';
import { setSelectedSubEntityId, convertQueueQueryObjToEdn } from '../../../redux/modules/entities';
import { getSelectedEntityId, userHasUpdatePermission, isCreating } from '../../../redux/modules/entities/selectors';
import { formSubmission, createFormName, getCurrentFormValueByFieldName } from '../../../redux/modules/form/selectors';

const CreateQueuesForm = compose(
  connect((state) => createFormName(state)),
  reduxForm({
    onSubmit: formSubmission,
    validate: formValidation,
    destroyOnUnmount: true,
    enableReinitialize: true,
  })
)(QueuesForm);

export function mapStateToProps(state) {
  return {
    basicQuery: getCurrentFormValueByFieldName(state, 'basicQuery'),
    dependentEntities: getQueuesPageDependentEntities(state),
    initialValues: getQueuesFormInitialValues(state),
    isAllDependentEntitiesFetched: isAllQueuesFormDependenciesFetched(state),
    isSaving: isCreating(state),
    key: getSelectedEntityId(state),
    matchmaker2Enabled: getMatchmaker2Enabled(state),
    querylevelCountInSelectedVersion: getSelectedVersionQuerylevelCount(state),
    selectedEntityId: getSelectedEntityId(state),
    selectedQueueVersionsNames: getSelectedQueueVersionsNames(state),
    tenantSlas: currentTenantSlas(state) ? currentTenantSlas(state) : [],
    userHasUpdatePermission: userHasUpdatePermission(state),
  };
}

export const actions = {
  setSelectedSubEntityId,
  convertQueueQueryObjToEdn,
};

export default connect(mapStateToProps, actions)(CreateQueuesForm);
